<template>
  <div v-if="product" class="product-info-sections">
    <ul class="product-info-sections__tabs">
      <li :class="['product-info-sections__tab', { active: tabs[0] == true }]">
        <button class="product-info-sections__tab-title" @click="setActive(0)">
          {{ $t('product.description') }}

          <icon-chevron-down class="product-info-sections__arrow" />
        </button>

        <div class="product-info-sections__tab-content">
          <product-description
            v-if="!lineItemEditor && productDescription"
            :desc="productDescription"
          />
        </div>
      </li>
      <li :class="['product-info-sections__tab', { active: tabs[1] == true }]">
        <button class="product-info-sections__tab-title" @click="setActive(1)">
          {{ $t('product.posting_days') }}

          <icon-chevron-down class="product-info-sections__arrow" />
        </button>

        <div class="product-info-sections__tab-content center-desktop">
          <product-posting-days
            v-if="product.posting_days"
            :posting-days="product.posting_days"
          />
        </div>
      </li>
      <li
        :class="[
          'product-info-sections__tab',
          'product-info-sections__tab--mobile',
          { active: tabs[2] == false },
        ]"
      >
        <div class="product-info-sections__tab-content center">
          <share-product v-if="!lineItemEditor" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import ProductDescription from '~/components/product/product-description/ProductDescription.vue'
import ProductPostingDays from '~/components/product/ProductPostingDays.vue'
import ShareProduct from '~/components/product/share-product/ShareProduct.vue'
import IconChevronDown from '~/components/icons/chevron-down/ChevronDownIcon'

export default {
  components: {
    ProductDescription,
    ProductPostingDays,
    ShareProduct,
    IconChevronDown,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    lineItemEditor: {
      type: Boolean,
      default: false,
    },
    productDescription: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      tabs: [true, false, false],
    }
  },
  methods: {
    setActive(i) {
      this.$set(this.tabs, i, !this.tabs[i])
    },
  },
}
</script>

<style lang="scss">
.product-info-sections {
  padding: 0;
  border-top: 15px solid $v4_color_line_lighter;
  border-bottom: 15px solid $v4_color_line_lighter;
  margin: 0;

  .product-info-sections__tabs-desktop {
    display: none;
  }

  .product-info-sections__tab-title {
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: $v4_color_line_lighter;
    padding: 15px;
    display: block;
    position: relative;
    color: $v4_color_text;
    font-size: 15px;
    text-decoration: none;
    background-color: white;
    width: 100%;
    text-align: left;
    cursor: pointer;
    border-radius: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    &:focus {
      outline: 0;
    }

    .product-info-sections__arrow {
      position: absolute;
      top: 50%;
      right: 15px;
      margin-top: -9px;
      width: 20px;
      fill: #a2a2a6;
      transition: transform 200ms ease-in-out;
    }
  }

  .product-info-sections__tab-content {
    display: none;
    padding: 20px 15px;
    font-size: 14px;
    line-height: 1.4;
    border-bottom: 1px solid $v4_color_line_lighter;
    color: #525256;

    > *:first-child,
    p:first-child {
      margin-top: 0;
    }
    > *:last-child,
    p:last-child {
      margin-bottom: 0;
    }
  }

  .product-info-sections__tab.active {
    .product-info-sections__arrow {
      transform: rotate(180deg) translateY(3px) translateX(3px);
    }
    .product-info-sections__tab-content {
      display: block;
    }
  }
}

@media (min-width: $v4_desktop) {
  html .product-info-sections {
    background-color: #f4f9fd;
    position: relative;
    border: 0;
    padding: 42px 0 60px;
    margin: 30px 0 0;

    .product-info-sections__tabs {
      max-width: 680px;
      margin: 0 auto;
      border-bottom: 1px solid #ece6e9;
    }

    .product-info-sections__tab--mobile {
      display: none;
    }

    .product-info-sections__tab-title,
    .product-info-sections__tab-content {
      padding-left: 0;
      padding-right: 0;
    }

    .product-info-sections__tabs
      li:first-child
      .product-info-sections__tab-title {
      border-top-width: 0;
    }

    .product-info-sections__tab-title {
      border-color: #ece6e9;
      border-width: 1px 0 0;
      background-color: transparent;
      font-weight: bold;
      font-size: 14px;
    }

    .product-info-sections__tab-content {
      padding-top: 0;
      border-width: 0;
    }
  }
}
</style>
